import angular    from 'angular'
import uiRouter   from 'angular-ui-router'

import AppConfig      from '../../src-generated/app.config'
import AppFooter      from './common/footer'
import AppHeader      from './common/header'
import BufferFactory  from './services/common/buffer.factory'
import I18n           from './common/i18n'
import Localization   from './common/localization'
import Maintenance    from './pages/maintenance'
import StoreTypes     from './common/store-types'

import component from './app.component'
import CookiesService from './services/cookies/cookies.service'

class UserServiceMock {getCurrentToken = () => {}}
class VehicleServiceMock {}

angular.module('maintenance', [
  uiRouter,
  AppConfig,
  AppFooter,
  AppHeader,
  I18n,
  Localization,
  Maintenance,
  StoreTypes
])

.config(($locationProvider, $qProvider, $urlRouterProvider) => {
  'ngInject'
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  $locationProvider.html5Mode(true).hashPrefix('!')
  $qProvider.errorOnUnhandledRejections(false)
  $urlRouterProvider.otherwise('maintenance')
})

.run(($log, Localization, StoreTypes, $location) => {
  'ngInject'

  if (Localization.getLocalizedAppConfig().type !== StoreTypes.STANDALONE) {
    $log.info('R-LINK Store embedded in an iframe...')
    require('./iframe.js')(Localization.getLocalizedAppConfig().rootUrl)
  }
})

.component('appMaintenance', component)
.factory('BufferFactory', BufferFactory)
.service('CookiesService', CookiesService)
.service('UserService', UserServiceMock)
.service('VehicleService', VehicleServiceMock)



// WEBPACK FOOTER //
// ./src/app/maintenance.js